/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S11_Li3_TextInputs */

const tr_onbilgi_s11_li3_text = /** @type {(inputs: Onbilgi_S11_Li3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows 10+, macOS 11+, Linux (modern dağıtım), iOS 15+, Android 11+ (mobil tarayıcı erişimi için).`)
};

const en_onbilgi_s11_li3_text = /** @type {(inputs: Onbilgi_S11_Li3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows 10+, macOS 11+, Linux (modern distribution), iOS 15+, Android 11+ (for mobile browser access).`)
};

const de_onbilgi_s11_li3_text = /** @type {(inputs: Onbilgi_S11_Li3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows 10+, macOS 11+, Linux (moderne Distribution), iOS 15+, Android 11+ (für den Zugang über mobile Browser).`)
};

const ru_onbilgi_s11_li3_text = /** @type {(inputs: Onbilgi_S11_Li3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows 10+, macOS 11+, Linux (современный дистрибутив), iOS 15+, Android 11+ (для доступа через мобильный браузер).`)
};

/**
* | output |
* | --- |
* | "Windows 10+, macOS 11+, Linux (modern distribution), iOS 15+, Android 11+ (for mobile browser access)." |
*
* @param {Onbilgi_S11_Li3_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s11_li3_text = /** @type {((inputs?: Onbilgi_S11_Li3_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S11_Li3_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s11_li3_text(inputs)
	if (locale === "de") return de_onbilgi_s11_li3_text(inputs)
	if (locale === "ru") return ru_onbilgi_s11_li3_text(inputs)
	return tr_onbilgi_s11_li3_text(inputs)
});